import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./FirstScreen.module.css";
import { ChooseLanguageScreenUrl } from "../App";
import gameConfig from "../gameConfig";

import gameNameImage from "../images/start-bubble.png";

function FirstScreen() {
  const navigate = useNavigate();

  const [langsScreenTimer, setLangsScreenTimer] = useState(null);

  const startShowLangsScreenTimer = () => {
    if (!langsScreenTimer) {
      setLangsScreenTimer(
        setTimeout(() => {
          navigate(ChooseLanguageScreenUrl);
        }, gameConfig.showFirstScreenTime)
      );
    }
  };

  const firstScreenSkip = useCallback(() => {
    // reset timer
    clearTimeout(langsScreenTimer);
    setLangsScreenTimer(null);
    // and show langs screen immediately
    navigate(ChooseLanguageScreenUrl);
  }, [langsScreenTimer, navigate]);

  if (!langsScreenTimer) {
    startShowLangsScreenTimer();
  }

  useEffect(() => {
    window.addEventListener("keydown", firstScreenSkip);
    return () => window.removeEventListener("keydown", firstScreenSkip);
  }, [firstScreenSkip]);

  return (
    <div className={styles.wrapper} onClick={firstScreenSkip}>
      <img src={gameNameImage} alt="game-name" className={styles.quizName} />
    </div>
  );
}

export default FirstScreen;
